(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-shared/invitation/assets/javascripts/use-link-generator.js') >= 0) return;  svs.modules.push('/components/marketplace-shared/invitation/assets/javascripts/use-link-generator.js');

'use strict';

const {
  encodeInitiationLink
} = svs.components.marketplaceShared.invitation;

const useLinkGenerator = (team, competition) => {
  if (!team || !competition) {
    return false;
  }
  const teamId = team.teamId || team.id;
  const teamName = team !== null && team !== void 0 && team.name ? encodeURIComponent(team.name.toString()) : '';
  const token = encodeInitiationLink('competition', team.invitationId, competition.id, teamId, teamName);
  const inviteLink = [window.location.protocol, '//', window.location.host.replace('app.', ''), svs.core.urlMapping.get('invitation'), '/', token].join('');
  return inviteLink;
};
setGlobal('svs.components.marketplaceShared.invitation.useLinkGenerator', useLinkGenerator);

 })(window);